import { useState, useRef } from 'react'

import type { IVariantTableMap, IVariantTableRow } from '../components/VariantTable'

const usePuzzleTable = () => {
  const [skuCombineList, setSkuCombineList] = useState<IVariantTableRow[]>([])
  const [priceBoundary, setPriceBoundary] = useState({ min: Infinity, max: -Infinity })
  const [inventories, setInventories] = useState<number>(0)

  const skuCombineMapRef = useRef<IVariantTableMap>({})

  return {
    skuCombineMapRef,
    skuCombineList,
    setSkuCombineList,
    priceBoundary,
    setPriceBoundary,
    inventories,
    setInventories,
  }
}

export default usePuzzleTable
